import { ProbabilityParams } from './probability.model';

export const COIN_FLIP_CONVERGENCE = {
  params: {
    experiment: 'coin',
    trialSizes: [10, 20, 50, 100, 200, 500, 1000],
    seed: 'coin-42',
    chartYAxisRange: [0.3, 0.7],
  } satisfies ProbabilityParams,
  height: 500,
};

export const DIE_ROLL_CONVERGENCE = {
  params: {
    experiment: 'die',
    trialSizes: [10, 20, 50, 100, 200, 500, 1000],
    seed: 'die-42',
    chartYAxisRange: [0, 0.4],
  } satisfies ProbabilityParams,
  height: 500,
};

export const PROBABILITY_PRESETS: Record<string, Record<string, unknown>> = {
  'coin-flip-convergence': COIN_FLIP_CONVERGENCE,
  'die-roll-convergence': DIE_ROLL_CONVERGENCE,
};
